import { WebComponent } from '@cian/mf-registry/browser';
import * as React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';

import { Application } from '../../../shared/containers/App';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { TReduxStore } from '../../../shared/types/redux';
import { activateHeaderUIAPIController } from '../headerUIAPIController/bridge';

export function createHeaderConstructor(
  context: IApplicationContext,
  store: TReduxStore,
  apiController: Parameters<typeof activateHeaderUIAPIController>[0],
): CustomElementConstructor {
  class Header extends WebComponent {
    private disposeAPIController: (() => void) | undefined;

    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/v2/get-header-microfrontend/';

    public async connectedCallback(): Promise<void> {
      const connected = super.connectedCallback();

      this.disposeAPIController?.();
      const disposeAPIController = activateHeaderUIAPIController(apiController);
      this.disposeAPIController = disposeAPIController;

      try {
        await connected;
      } catch (error) {
        if (this.disposeAPIController === disposeAPIController) {
          disposeAPIController();
          this.disposeAPIController = undefined;
        }
        throw error;
      }
    }

    public disconnectedCallback(): void {
      this.disposeAPIController?.();
      this.disposeAPIController = undefined;
      super.disconnectedCallback();
    }

    public async render() {
      const reactElement = <Application {...this.props} context={context} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return Header;
}
